import React from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { WContainer, WImage } from '@next-nx/shared-ui/atoms'
import styles from './LandingServiziMobilitaSection.module.sass'
import { getIcon } from '@next-nx/utils/icons'


interface Props {
  item?: MenuItemType | undefined
  className?: string
}

const LandingServiziMobilitaSection = (props: Props) => {

  const { 
    item = undefined,
    className = '',
  } = props

  return item ? (
    <div className={`${styles.landingServiziMobilitaSection} ${className}`}>
      <div className={styles.bg}>
        <div className={styles.circle}></div>
        <WContainer>
          <div className={styles.content}>
            <div className={styles.imageBox}>
              <WImage 
                src={item.image}
                alt={item.name}
                title={item.name}
                maxWidth={515}
                maxHeight={357}
                layout="intrinsic"
              />
            </div>
            {!!item.name && <p className={styles.title}>{item.name}</p>}
            {item.children && item.children?.edges?.length > 0 && (
            <div className={styles.list}>
              {item.children?.edges.map((x, i) => (
                <div className={`${styles.item} ${
                  i < 2 ? styles['item--prev-md'] : i > Math.floor((item.children.edges.length - 2) / 3) * 3 + 1 ? styles['item--next-md'] : ''
                } ${ 
                  i < 3 ? styles['item--prev-lg'] : i > Math.floor((item.children.edges.length - 3) / 4) * 4 + 2 ? styles['item--next-lg'] : ''
                }`} key={x.node.pk}>
                  <div className={styles.itemIcon}>{getIcon(x.node.style)}</div>
                  {!!x.node.name && <p className={styles.itemTitle} dangerouslySetInnerHTML={{ __html: x.node.name }} />}
                  {!!x.node.description && <div className={styles.itemDescription} dangerouslySetInnerHTML={{ __html: x.node.description }} />}
                </div>
              ))}
            </div>
            )}
          </div>
        </WContainer>
      </div>
    </div>
  ) : <></>
}

export default LandingServiziMobilitaSection
